import styled, { css } from "styled-components";

const labelStyles = css`
  ${(props) => props.labelStyles}
`;
const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 1.375rem;
  overflow-y: auto;
`;

export const OuterWrapper = styled.div`
  padding: 0px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  font-size: 14px;
  color: #ffffff;
  line-height: 1rem;
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  border-top: ${(props) => props.borderTop ?? "0px solid #767676"};
  border-bottom-right-radius: ${(props) => props.borderRadius ?? "0px"};
  border-bottom-left-radius: ${(props) => props.borderRadius ?? "0px"};
  padding: ${(props) => props.padding ?? "0px"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#474747"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  align-content: ${(props) => props.alignContent ?? "center"};
  padding: ${(props) => props.padding ?? "0px"};
  align-items: center;
`;

export const RadioItem = styled.div`
  margin-top: 3px;
  align-items: center;
`;

export const RowHeader = styled.div`
  background-color: #008395;
  justify-content: space-between;
  padding: 0px 0px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const SolutionOuter = styled.div`
  max-height: 20rem;
  overflow-y: scroll;
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 3px 5px;
  background-color: white;
  padding: 10px 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  border: solid 1px #cdcdcd;
  margin-bottom: 10px;
  opacity: ${(props) => props.opacity ?? "1"};
`;

export const ErrorDiv = styled.div`
  height: auto;
  border: ${(props) => props.border ?? "solid 1px #f08046"};
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: ${(props) => props.color ?? "#f08046"};
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1.2;
  margin: 0;
  padding: 0;
`;
